import {Component, Input, OnInit} from '@angular/core';
import {AppService} from '@api';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

@Component(
    {
        selector: 'colaborador_detalle',
        templateUrl: './colaborador_detalle.template.html',
        styleUrls: ['./colaborador.component.scss']
    })

export class ColaboradorDetalleComponent implements OnInit {
    @Input() ColaboradorId!: number;
    hijo!: Array<any>;
    horario!: Array<any>;
    horarioespecial!: Array<any>;
    estudio!: Array<any>;
    puesto!: Array<any>;
    puestohistorial!: Array<any>;

    constructor(private appService: AppService) {
    }

    ngOnInit() {
        this.Hijo();
        this.Horario();
        this.Estudio();
        this.Puesto();
    }

    Hijo() {
        this.appService.Get("configuracionrh/colaborador/hijo/" + this.ColaboradorId).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.hijo = res.data;
            }
        })
    }

    Estudio() {
        this.appService.Get("configuracionrh/colaborador/estudio/" + this.ColaboradorId).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.estudio = res.data;
            }
        })
    }

    Horario() {
        this.appService.Get("configuracionrh/colaborador/horario/" + this.ColaboradorId).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.horario = res.data.horario;
                this.horarioespecial = res.data.horarioespecial;
            }
        });
    }
    
    Puesto() {
        this.appService.Get("configuracionrh/colaborador/puesto/" + this.ColaboradorId).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.puesto = res.data.actual;
                this.puestohistorial = res.data.historial;
            }
        })
    }
}
